import { axiosAuthClient } from "..";
import { handleError } from "../../utils/errors";

class AuthService {
  sendCode = async (data) => {
    try {
      const response = await axiosAuthClient.post("/send-code", data, {
        withCredentials: true,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      const { accessToken, user, isNewUser } = response.data.data;

      return {
        accessToken,
        user,
        isNewUser,
      };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while logging in, status:" + err.code
      );
    }
  };

  logout = async () => {
    try {
      const response = await axiosAuthClient.get("/logout", {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return;
    } catch (err) {
      throw handleError(err, "Error occurred while logging out");
    }
  };

  refresh = async () => {
    try {
      const response = await axiosAuthClient.get("/refresh-token", {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      const { accessToken } = response.data.data;
      return { accessToken };
    } catch (err) {
      throw handleError(err, "Error occurred while refresh token");
    }
  };

  verifyEmail = async (data) => {
    try {
      const response = await axiosAuthClient.post("/verify-email", data, {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while verifying email");
    }
  };
}

const authService = new AuthService();

export default authService;
